






















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { secondsToText } from "../utils";

@Component
export default class Player extends Vue {
  @Prop() private progressPercentage: number = 0;
  @Prop() private videoDuration: number = 0;
  @Prop() private isPlayFromAudioStatement!: boolean;
  @Prop({ default: 1 }) private playbackRate!: number;

  private totalDuration: string = "";
  private currentDuration: string = "0:00";
  @Prop() private isVideoPlaying!: boolean;
  //private isPlayingFromStatement: boolean = false;

  private handleBarClick(e: MouseEvent) {
    if (this.videoDuration > 0) {
      let playbackBar: HTMLElement = this.$refs.playbackBar as HTMLElement;
      let perc = e.offsetX / playbackBar.offsetWidth;
      let currentTime = perc * this.videoDuration;
      this.$emit("videoCurrentTimeChanged", currentTime);
    }
  }

  private togglePlayback() {
    let isPlaying = !this.isVideoPlaying;
    this.$emit("isVideoPlaying", isPlaying);
  }

  private togglePlaybackRate() {
    this.$emit("playbackRateChanged", this.playbackRate === 2 ? 1 : 2);
  }

  @Watch("progressPercentage")
  private onProgressChange() {
    if (this.progressPercentage == 100) {
      this.togglePlayback();
    }
    let currentTime = (this.progressPercentage * this.videoDuration) / 100;
    this.currentDuration = secondsToText(currentTime);
  }

  @Watch("videoDuration")
  private onDurationChange() {
    this.totalDuration = secondsToText(this.videoDuration);
  }
}
